export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] text-white/40">
              Innovación · Turismo · Marketing
            </div>
            <h2 className="font-display mt-4 text-3xl md:text-4xl uppercase tracking-tight text-white/80 max-w-xl">
              Locura con método. <br />
              <span className="text-white">Resultados con propósito.</span>
            </h2>
          </div>
          <div className="md:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">
                Navegar
              </div>
              <ul className="space-y-3 text-sm">
                {[
                  ["Metodología", "#metodologia"],
                  ["Servicios", "#servicios"],
                  ["Sobre Tony", "#sobre"],
                  ["Contacto", "#contacto"],
                ].map(([l, h]) => (
                  <li key={h}>
                    <a
                      href={h}
                      data-testid={`footer-link-${h.replace(/[#/]/g, "")}`}
                      className="text-white/70 hover:text-white"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">
                Contacto
              </div>
              <ul className="space-y-3 text-sm">
                <li>
                  <a
                    href="https://wa.me/525543607330"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-whatsapp"
                    className="text-white/70 hover:text-accent inline-flex items-center gap-2"
                  >
                    WhatsApp <span className="text-white/40">·</span>
                    <span className="font-mono text-xs">+52 55 4360 7330</span>
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:tony@incubatour.com"
                    data-testid="footer-email"
                    className="text-white/70 hover:text-accent"
                  >
                    tony@incubatour.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/tonyyarto/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-linkedin"
                    className="text-white/70 hover:text-accent"
                  >
                    LinkedIn
                  </a>
                  <span className="text-white/30 mx-2">·</span>
                  <a
                    href="https://instagram.com/tonyyarto"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram"
                    className="text-white/70 hover:text-accent"
                  >
                    Instagram
                  </a>
                </li>
                <li className="text-white/50 text-xs pt-1">
                  México · Colombia · España
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* MASSIVE wordmark */}
        <div
          aria-hidden
          className="font-display font-black tracking-tighter leading-none uppercase select-none text-[22vw] md:text-[15vw] text-white whitespace-nowrap overflow-hidden"
        >
          TONY YARTO
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/10 pt-6">
          <div className="text-xs text-white/40">
            © 2026 Tony Yarto. Todos los derechos reservados.
          </div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-white/30">
            Locura con método · MX · CO · ES
          </div>
        </div>
      </div>
    </footer>
  );
}
